<template>
  <FormSect :title="$t('title')">
    <Btn
      slot="titleSide"
      class="sm ib"
      icon="search"
      :isLoading="isSearching"
      @click="searchReviews">
      {{ $t('search') }}
    </Btn>
    <div v-if="doShowSearch">
      <SearchResult
        v-for="result in results"
        :key="result.link"
        :laptop="laptop"
        :searchResult="result"
        @add="addReviewExternal" />
    </div>
    <MultiForm
      v-if="laptop.reviewsExternal"
      :items.sync="laptop.reviewsExternal"
      @add="addReviewExternal">
      <template #default="{ item }">
        <FormReviewExternal
          :isLoading="isFetching"
          :laptopParent="laptop"
          :reviewExternal="item"
          @fetch="fetchReviewData"
          @fetchMerge="fetchMerge" />
      </template>
      <Btn
        v-show="laptop.reviewsExternal.length"
        slot="buttons"
        class="sm ib success"
        :isLoading="isFetching"
        @click="fetchMergeAll">
        {{ $t('fetchMergeAll') }}
      </Btn>
    </MultiForm>
  </FormSect>
</template>

<script>
import { actions, getters } from '@utils'
import { head, mergeRight, pick, pipe } from 'rambda'
import FormReviewExternal from './FormReviewExternal'
import MultiForm from '@forms/MultiForm'
import SearchResult from './SearchResult'
import implySiteName from './implySiteName'
import mergeReviewsExternal from './mergeReviewsExternal'

export default {
  components: {
    FormReviewExternal,
    MultiForm,
    SearchResult,
  },
  props: {
    laptop: Object,
  },
  data() {
    return {
      doShowDiff: false,
      doShowSearch: false,
      results: [],
      isSearching: false,
      isFetching: false,
    }
  },
  computed: getters('laptopReviewExternalFactory'),
  methods: {
    async fetchReviewData(reviewsExternal) {
      const laptops = await this.$wrap(
        () => this.FIND_LAPTOP_FILLER({
          id: this.laptop.id,
          reviewsExternal,
        }),
        'isFetching',
      )

      const laptopMerged = pipe(
        head,
        mergeReviewsExternal(this.laptop.reviewsExternal),
        pick(['reviewsExternal']),
        mergeRight(this.laptop),
      )(laptops)

      this.$up('laptop', laptopMerged)
    },
    fetchMergeAll() {
      return this.fetchMerge(this.laptop.reviewsExternal)
    },
    async fetchMerge(reviewsExternal) {
      const laptop = await this.$wrap(
        () => this.CREATE_LAPTOP_FILLER({
          id: this.laptop.id,
          reviewsExternal,
        }),
        'isFetching',
        this.$t('merged'),
      )

      const laptopMerged = pipe(
        mergeRight(this.laptop),
        mergeReviewsExternal(this.laptop.reviewsExternal),
      )(laptop)

      this.$up('laptop', laptopMerged)
    },
    addReviewExternal(overwrites = {}) {
      const reviewExternal = pipe(
        this.laptopReviewExternalFactory,
        reviewExternal => ({
          ...reviewExternal,
          siteName: implySiteName(reviewExternal.url),
        }),
      )(overwrites)

      return this.laptop.reviewsExternal
        .push(reviewExternal)
    },
    searchReviews() {
      return this.$wrap(
        async () => {
          this.doShowSearch = true
          this.results = await this.FIND_REVIEW_SEARCH({
            laptopId: this.laptop.id,
          })
        },
        'isSearching',
      )
    },
    ...actions(
      'CREATE_LAPTOP_FILLER',
      'FIND_LAPTOP_FILLER',
      'FIND_REVIEW_SEARCH',
    ),
  },
}
</script>

<style lang="scss">
.FormLaptopReviews {
}
</style>

<i18n>
{
  "en": {
    "fetchMergeAll": "Fetch All & Merge",
    "merged": "Merged",
    "title": "Reviews",
    "search": "Search"
  }
}
</i18n>
